// verifies customer login state (eventually saves customer data to the state) and refreshes active token when needed

export default defineNuxtRouteMiddleware(async to => {
    //useCustomer().initializeCustomer();
})